import { render, staticRenderFns } from "./riskIndicators.vue?vue&type=template&id=b94e5e7a&scoped=true&"
import script from "./riskIndicators.vue?vue&type=script&lang=js&"
export * from "./riskIndicators.vue?vue&type=script&lang=js&"
import style0 from "./riskIndicators.vue?vue&type=style&index=0&id=b94e5e7a&lang=scss&scoped=true&"
import style1 from "./riskIndicators.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94e5e7a",
  null
  
)

export default component.exports